import { Dayjs } from 'dayjs'
import { TimeInput } from 'govwell-ui'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  field: TanstackField<Dayjs | null | undefined, TKey>
  label?: React.ReactNode
  isRequired?: boolean
}
const TimeField = <TKey extends string>({ caption, field, label, isRequired }: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  return (
    <TimeInput
      caption={caption}
      errorMessage={errorMessage}
      isInvalid={!!errorMessage}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      value={field.state.value}
      isRequired={isRequired}
    />
  )
}

export default TimeField
